import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/contacto/contacto.component.ts